const videos = [
  'https://www.interesnee.ru/videos/culture/18_year.mp4',
  'https://www.interesnee.ru/videos/culture/15_year.mp4',
  'https://www.interesnee.ru/videos/culture/16_year.mp4',
  'https://www.interesnee.ru/videos/culture/summer-2021.mp4',
  'https://www.interesnee.ru/videos/culture/summer-2020.mp4',
  'https://www.interesnee.ru/videos/culture/13-12-14.mp4',
  'https://www.interesnee.ru/videos/culture/summer_2023.mp4',
];

const previews = [
  '/images/photos/culture-video-preview/18_year_mp4-preview.webp',
  '/images/photos/culture-video-preview/15_year-min.jpg',
  '/images/photos/culture-video-preview/16_year-min.jpg',
  '/images/photos/culture-video-preview/summer-2021-min.jpeg',
  '/images/photos/culture-video-preview/summer-2020-min.jpeg',
  '/images/photos/culture-video-preview/13-12-14-min.jpeg',
  '/images/photos/culture-video-preview/summer_2023.png',
];

export default {
  videos,
  previews,
};



// WEBPACK FOOTER //
// ./src/data/culture-videos.js